import {cn} from '@/lib/utils';
import {StrapiMenuItem} from '@/types/strapi';
import {useLocale} from 'next-intl';
import {ReactNode} from 'react';
import NavigationSubMenu from '../NavigationSubMenu';

type Props = {
  children?: ReactNode;
  sideMenu?: {title?: string; content?: StrapiMenuItem[]; classname?: string};
  banners?: any;
};
export default function DefaultTemplate({
  children,
  sideMenu = {},
  banners = []
}: Props) {
  const lang = useLocale();
  return (
    <div className={cn('container md:flex md:pb-[40px]')}>
      {(sideMenu?.content || []).length > 0 && (
        <div
          className={cn(
            'w-full md:w-[30%] overflow-x-hidden',
            banners?.length == 0 && 'pt-7',
            sideMenu?.classname
          )}
        >
          <NavigationSubMenu
            lang={lang}
            menu={sideMenu?.content || []}
            title={sideMenu?.title}
          />
        </div>
      )}

      <div
        className={cn(
          'relative flex grow flex-col px-4 md:pl-0 w-full',
          (sideMenu?.content || []).length > 0 && 'md:w-[70%]'
        )}
      >
        <div
          className={cn('md:text-[18px] min-h-[calc(100vh-600px)] relative')}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
